/**
 * 获取userAgent
 */
export const getUserAgent = () => {
  return window.navigator.userAgent;
};
export const ClientUA = getUserAgent().toLowerCase();
/**
 * 是否安卓系统
 * @returns boolean
 */
export const isAndroid = () => {
  return ClientUA.includes("android") || ClientUA.includes("linux");
};
/**
 * 是否鸿蒙系统
 * @returns boolean
 */
export const isHarmony = () => {
  return ClientUA.includes("harmony");
};
/**
 * 是否IOS系统
 * @returns boolean
 */
export const isIos = () => {
  return /(iphone|ipad|ipod|ios|mac os x)/i.test(ClientUA);
};
/**
 * 是否Iphone设备
 * @returns boolean
 */
export const isIphone = () => {
  return ClientUA.includes("iphone");
};
/**
 * 是否Ipad设备
 * @returns boolean
 */
export const isIpad = () => {
  return ClientUA.includes("ipad");
};
/**
 * 是否微信小程序终端
 * @returns boolean
 */
export const isWeApp = () => {
  return ClientUA.includes("miniprogram");
};
/**
 * 是否抖音小程序终端
 * @returns boolean
 */
export const isTTMiniApp = () => {
  return ClientUA.includes("toutiaomicroapp");
};
/**
 * 是否微信终端(非企微)
 * @returns boolean
 */
export const isWechat = () => {
  return ClientUA.includes("micromessenger") && !isWorkWechat();
};
/**
 * 是否阿维塔App终端
 * @returns boolean
 */
export const isAvatrApp = () => {
  return ClientUA.includes("avatr") || ClientUA.includes("avatar");
};
/**
 * 是否百度小程序
 * @returns boolean
 */
export const isBaiduApp = () => {
  return ClientUA.includes("swan-baiduboxapp");
};
/**
 * 是否企业微信
 * @returns boolean
 */
export const isWorkWechat = () => {
  return ClientUA.includes("wxwork");
};
/**
 * 运行终端设备及环境信息
 */
export const ClientInfo = {
  ClientUA,
  isAvatrApp: isAvatrApp(),
  isAndroid: isAndroid(),
  isIos: isIos(),
  isHarmony: isHarmony(),
  isIphone: isIphone(),
  isIpad: isIpad(),
  isWeApp: isWeApp(),
  isWechat: isWechat(),
  isBaiduApp: isBaiduApp(),
  isWorkWechat: isWorkWechat(),
  isTTMiniApp: isTTMiniApp()
};